import dayjs from 'dayjs';

type SameAddressDeleteEvent = {
  id: string | number;
  visit_datetime_from: string;
  same_visit_id?: number | null;
  group_count?: number | null;
};

export type SameAddressDeleteWarning = {
  before: number;
  after: number;
};

export function buildSingleDeleteSameAddressWarning(
  target: SameAddressDeleteEvent | null | undefined,
  events: SameAddressDeleteEvent[],
  pendingDeletedVisitIds: number[]
): SameAddressDeleteWarning | null {
  if (!target?.same_visit_id) return null;

  const targetDate = dayjs(target.visit_datetime_from).format('YYYY-MM-DD');
  const deletedIds = new Set(pendingDeletedVisitIds);
  const sameAddressVisits = events.filter(event => {
    if (typeof event.id === 'number' && deletedIds.has(event.id)) return false;
    return (
      event.same_visit_id === target.same_visit_id &&
      dayjs(event.visit_datetime_from).format('YYYY-MM-DD') === targetDate
    );
  });

  const backendGroupCount = Number(target.group_count ?? 0);
  const before = Math.max(backendGroupCount, sameAddressVisits.length);

  if (before < 2) return null;

  return {
    before,
    after: Math.max(before - 1, 0),
  };
}
